import axios from 'axios';
import { supabase } from '../utils/supabase';

// Base URL configuration
const BASE_URL = process.env.REACT_APP_API_URL || 'http://192.168.1.197:8000';

// Create axios instance with interceptors
const axiosInstance = axios.create({
  baseURL: BASE_URL,
});

// Request interceptor to add auth token
axiosInstance.interceptors.request.use(
  async (config) => {
    const { data: { session } } = await supabase.auth.getSession();
    
    if (session?.access_token) {
      config.headers.Authorization = `Bearer ${session.access_token}`;
    }
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle auth errors
axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response?.status === 401) {
      // Token might be expired, try to refresh
      const { data: { session } } = await supabase.auth.getSession();
      if (!session) {
        // No valid session, redirect to login
        await supabase.auth.signOut();
      }
    }
    return Promise.reject(error);
  }
);

// API client with authentication
const apiClient = {
  get: async (endpoint) => {
    const response = await axiosInstance.get(endpoint);
    return response.data;
  },

  post: async (endpoint, data) => {
    const response = await axiosInstance.post(endpoint, data);
    return response.data;
  },

  delete: async (endpoint, data) => {
    const response = await axiosInstance.delete(endpoint, { data });
    return response.data;
  },

  put: async (endpoint, data) => {
    const response = await axiosInstance.put(endpoint, data);
    return response.data;
  }
};

export { BASE_URL, apiClient };